import { useEffect, useState } from 'react';
import { useMobile } from '@shared/hooks/use-mobile.ts';

export const useScroll = (pos?: number) => {
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [hideHeader, setHideHeader] = useState(false);
  const [hideNav, setHideNav] = useState(false);

  const [transformHeader, setTransformHeader] = useState('translateY(0)');
  const [transformNav, setTransformNav] = useState('translateY(44px)');

  const [paddingTop, setPaddingTop] = useState<string>('20px');

  const { isMobile } = useMobile();

  const isCanNavHide = false; // чтобы навбар скрывался изменить на true
  const isCanAllHide = isMobile; // по таске от 18.10.2024 полосы не скрываются на декстопе

  useEffect(() => {
    if (isMobile) {
      setPrevScrollPos(0);
      setHideHeader(false);
      setHideNav(false);
      setTransformHeader('translateY(0)');
      setTransformNav('translateY(44px)');
      setPaddingTop('20px');
    }

    const resetPosition = () => {
      setPrevScrollPos(0);
      setHideHeader(false);
      setHideNav(false);
      setTransformHeader('translateY(0)');
      setTransformNav('translateY(44px)');
      setPaddingTop('20px');
    };

    window.addEventListener('resize', resetPosition);

    return () => {
      window.removeEventListener('resize', resetPosition);
    };
  }, [isMobile]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      // плавное скрытие и хедера и навбара
      if (isCanNavHide) {
        currentScrollPos > 44 ? setHideHeader(true) : setHideHeader(false);

        if (currentScrollPos > 150 && prevScrollPos < currentScrollPos) setHideNav(true);
        if (currentScrollPos > 150 && prevScrollPos > currentScrollPos) setHideNav(false);
        if (currentScrollPos < 150) setHideNav(false);

        if (hideHeader && hideNav) {
          setTransformHeader('translateY(-34px)');
          setTransformNav('translateY(-94px)');
        }

        if (hideHeader && !hideNav) {
          setTransformHeader('translateY(-33px)');
          setTransformNav('translateY(10px)');
        }

        if ((!hideHeader && !hideNav) || (!hideHeader && hideNav) || currentScrollPos === 0) {
          setTransformHeader('translateY(0)');
          setTransformNav('translateY(44px)');
        }
      }

      // плавное скрытие только хедера. навбра будет виден всегда
      if (!isCanNavHide) {
        if (currentScrollPos > 44 && prevScrollPos < currentScrollPos) setHideHeader(true);
        if (currentScrollPos > 44 && prevScrollPos > currentScrollPos) setHideHeader(false);
        if (currentScrollPos < 44) setHideHeader(false);

        if (hideHeader && !hideNav) {
          setTransformHeader('translateY(-33px)');
          setTransformNav('translateY(10px)');
        }

        if ((!hideHeader && !hideNav) || (!hideHeader && hideNav) || currentScrollPos === 0) {
          setTransformHeader('translateY(0)');
          setTransformNav('translateY(44px)');
        }
      }

      if (pos !== undefined && prevScrollPos !== currentScrollPos) {
        if (pos > 70) {
          setPaddingTop('20px');
        }

        if (pos > 20 && pos <= 70) {
          // console.log('firstBlock');
          if (hideNav) {
            // console.log('kek');
            setPaddingTop('20px');
          }
          if (!hideNav) {
            setPaddingTop(`${70 - pos < 20 ? 50 : 70 - pos}px`);
            // console.log('lol');
          }
        }

        if (pos <= 20) {
          // console.log('SecondBlock');
          if (!hideNav) {
            // console.log('kek');
            setPaddingTop(`${70 - pos <= 10 ? 10 : 134 - pos}px`);
          }
          if (hideNav) {
            // console.log('lol');

            setPaddingTop(`${54}px`);
          }
        }
      }

      setPrevScrollPos(currentScrollPos);
    };

    if (isCanAllHide) {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [hideHeader, hideNav, isCanAllHide, isCanNavHide, pos, prevScrollPos, isMobile]);

  return {
    paddingTop,
    prevScrollPos,
    transformHeader,
    transformNav,
    hideHeader,
    hideNav,
  };
};
